import { render, staticRenderFns } from "./PermissionsTree.vue?vue&type=template&id=6554ab60&scoped=true&"
import script from "./PermissionsTree.vue?vue&type=script&lang=js&"
export * from "./PermissionsTree.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsTree.vue?vue&type=style&index=0&id=6554ab60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6554ab60",
  null
  
)

export default component.exports